<div class="header">
    <i class="fa fa-lock header-icon shadow-animation" aria-hidden="true"></i>
</div>
<h5 class="card-title">Reserva Finalizada</h5>
<div class="d-grid gap-2 d-md-block">
    <button class="btn btn-dark m-1" (click)="goToHome()" type="button">Voltar para o menu principal</button>
</div>